import BaseContainer from "@components/ui/BaseContainer";
import { useTranslation } from "react-i18next";
import classes from "./Services.module.scss";
import clsx from "clsx";
import { AnimationOnScroll } from "react-animation-on-scroll";
import Accordion from "@components/ui/Accordion";

const Services = () => {
  const { t } = useTranslation();

  const list: {
    title: string;
    subtitle: string;
    price: string;
    description: string;
  }[] = t("services.list", { returnObjects: true });

  return (
    <BaseContainer className={classes["services"]} id="services">
      <h3 className={classes.services__title}>{t("services.title")}</h3>
      <ul className={classes.services__list}>
        {list.map((item, index) => (
          <li
            key={item.title}
            className={clsx(classes.services__item, classes.item)}
          >
            <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce>
              <Accordion
                title={item.title}
                subtitle={item.subtitle}
                price={item.price}
                description={item.description}
              />
            </AnimationOnScroll>
          </li>
        ))}
      </ul>
    </BaseContainer>
  );
};

export default Services;
